import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, Paper, Stack, Text } from '@mantine/core';
export const KycIdVerification: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    successes,
    setVerifyStatus
  } = useVerifyAction();
  const handleClick = () => {
    setVerifyStatus(STATUS.ID_VERIFICATION);
    successes.add(STATUS.ID_VERIFICATION);
  };
  return <Stack gap={0} mt={40} visibleFrom="lg">
      <Text fz={25} className={gunterzBold.className} ta="center">
        {i18n._('ID VERIFICATION')}
      </Text>

      <Paper px={20} py={34} mt={40} bd="2px dashed var(--text-prime)" bg="#1A1F26F2" pos="relative">
        <Image src="/assets/kyc/id_verification.svg" alt="verification" w={52} h={52} mx="auto" pos="absolute" top={-30} left={0} right={0} />
        <Stack align="center">
          <Text fz="lg" c="var(--text-prime)" className={gunterzBold.className}>
            {i18n._('Final Step!')}
          </Text>
          <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta="center" maw={285}>
            {i18n._('You’ll need to upload a valid ID and complete a quick proof of life check. This is the last step before you unlock your armor and boost your in-game rewards!')}
          </Text>

          <Image src="/assets/wallet/qr_code.svg" alt="qr-code" w={180} h={180} onClick={handleClick} />

          <Text tt="uppercase" fz="xs" c="var(--text-prime)" fw={700}>
            {i18n._('Scan the QR code to continue')}
          </Text>
        </Stack>
      </Paper>
    </Stack>;
};